<template>
    <MainPage @clickBack="gotoMain()">
        <template v-slot:header>
            <!-- <div class="header-mobile"> -->
                <!-- <img @click="clickBack()" class="icon-back" src="@/assets/icon/ic-back-mobile.svg" alt=""> -->
                <div class="header-title">
                    {{ lbl.changePassword.title }}
                </div>
            <!-- </div> -->
            <!-- <div class="page-detail">For your account's security, do not share your password with anyone else </div> -->
        </template>
        <div class="from-change-password">
            <ChangePasswordFrom @onChangePassword="changePassword($event)"></ChangePasswordFrom>
        </div>
        <ModalMaster :controller="modalController"></ModalMaster>
    </MainPage>
</template>

<script>
import ConfigManager from '@/config/ConfigManager';
import BzbsProfile from '@/core/Account/service/BzbsProfile.js';
import Account from '@/helper/AccountHelper.js'
import MainPage from '@/components/Layout/Page/MainPage.vue';
import ModalMixin from "@/mixin/ModalMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js"
import ChangePasswordFrom from '@/module/ChangePassword/component/ChangePasswordFrom.vue';
export default {
    name: 'ChangePassword',
    mixins: [ModalMixin,LocaleMixin],
    components: {
        MainPage,
        ChangePasswordFrom,
    },
    created: function() {
    },
    methods: {
        gotoMain: function() {
            this.$router.back()
        },
        changePassword: function (password) {
            console.log(password)
            this.passwordCurrent = password.CurrentPassword
            this.passwordChange = password.NewPassword
            this.confirmModal
                .setTitle(this.lbl.changePassword.confirm_popup.title)
                .setMsg(this.lbl.changePassword.confirm_popup.msg)
                .setBtnOk(this.lbl.changePassword.confirm_popup.btn_ok)
                .setBtnCancel(this.lbl.changePassword.confirm_popup.btn_cancel)
                .show()
            this.confirmModal.onClickOk(() => {
                console.log('click ok')
                this.changeBzbsPassword();
            });
        },
        // openOTP: function () {
        //     console.log('otpmodal')
        //     //set loadingModal & alertModal
        //     this.modalController.otpModal.setLoadingModal(this.modalController.loadingModal)
        //     this.modalController.otpModal.setAlertModal(this.modalController.alertModal)
        //     //start otp
        //     // this.modalController.otpModal.startOtp(this.paramsRegister.contactNumber, 'buzzebees')
        //     this.modalController.otpModal.startOtp(this.paramsRegister.contactNumber, 'register')
        //     this.modalController.otpModal.onSubmitOtp((otp)=>{
        //         console.log(otp)
        //         this.paramsRegister.otp = otp.otp;
        //         this.paramsRegister.refcode = otp.refcode;
        //         this.changeBzbsPassword();
        //     })
        // },
        changeBzbsPassword: function(){
            return new Promise((resolve, reject) => {
            var strToken = Account.getToken()
            BzbsProfile.changePassword(strToken , this.passwordCurrent , this.passwordChange).subscribe((data) => {
                    console.log(data)
                    this.changePasswordSuccess()
                    resolve(data);
                }, (err) => {
                    this.modalController.alertModal
                        .clearModal()
                        .setTitle(err.message)
                        .setMsg(err.message)
                        .setBtnOk()
                        .show()
                    reject(err);
                })
            });
        },
        changePasswordSuccess: function() {
            this.confirmModal
                .setTitle(this.lbl.changePassword.Success_popup.title)
                .setMsg(this.lbl.changePassword.Success_popup.msg)
                .setBtnOk(this.lbl.changePassword.Success_popup.btn_ok)
                .setShowBtnCancel(false)
                .show()
            this.confirmModal.onClickOk(() => {
                Account.setLogout()
                let appId = ConfigManager.getAppId()
                let url = '/login';
                if (appId != 5301489996600029) {
                    url = '/login' + '?app_id=' + appId;
                }
                this.$router.push(url)
            });
        }
    },
}
</script>

<style lang="scss" scoped>
    @import "@/style/base/base.scss";

    .bg-content {
        @include max-mobile {
            background: $main-orange-color;
        }
    }
    .page-detail {
        font-family: 'PRT-Regular';
        font-size: 16px;
        @include max-mobile {
            display: none;
        }
    }
    .from-change-password {
        margin: 20px auto 0;
        padding: 30px 0 42px ;
        background-color: white;
        border-radius: 5px;
        @include max-mobile {
            padding: 0px 16px 0px;
            margin: {
                left: 20px;
                right: 20px;
            }
            // height: calc(100vh - 64px);
        }
    }
</style>

